import { Site } from "@/types/v2";
import { IndexDBService } from "../index_db";

export const SitesStorageService = {
  getSites: async (): Promise<Site[]> => {
    const sites = await IndexDBService.get<Site[]>("sites");
    return sites || [];
  },

  getActiveSite: async (): Promise<Site | null> => {
    return await IndexDBService.get<Site>("activeSite");
  },

  getSiteByKey: async (key: string): Promise<Site | null> => {
    const sites = await SitesStorageService.getSites();
    return sites.find((site) => site.key === key) || null;
  },

  storeSites: async (sites: Site[]): Promise<void> => {
    await IndexDBService.set("sites", sites);
  },

  storeActiveSite: async (site: Site): Promise<void> => {
    await IndexDBService.set("activeSite", site);
  },
};
